import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { VeiculoModel } from '@data/veiculo/models';

@Injectable()
export class VeiculoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.VEICULOS);
  }

  filter(search: string) {
    return this.getRequest<{ data: { results: VeiculoModel[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
      limit: 10,
    }).pipe(
      map(({ data }) =>
        data.results.map((item) => ({
          label: item.placa,
          value: item.id,
        })),
      ),
    );
  }
}
